export {Alert} from 'antd';
export type {AlertProps} from 'antd/es/alert/index';
